import ButtonPrimary from 'components/ButtonPrimary'
import { LoadingIcon } from 'components/Icon/icons/loading'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import workoutMessages from 'modules/workout/redux/messages'
import { getWidthViewportSelect } from 'modules/viewport/selectors'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

export default function FloatingStartWorkoutButton ({
  isLoading,
  onClick,
  isDisabled
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const width = useSelector(getWidthViewportSelect)
  return (
    <View
      w='100%'
      bgc='white'
      py={2}
      jc
      ac
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        justifyContent: 'space-around',
        alignItems: 'center',
        borderTop: '1px solid #00000038',
        zIndex: 2
      }}
    >

      <ButtonPrimary
        isDisabled={isDisabled}
        isFullWidth
        onClick={onClick}
        style={{
          width: `${isSmallScreen
            ? width * 0.85
            : '500'}px`,
          height: '50px',
          background: '#1C1C1E',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '12px',
          maxWidth: 'unset'
        }}
      >
        <Text
          ml='0.60em'
          fw='600'
          c='#FFFFFF'
          style={{ textTransform: 'uppercase' }}
        >
          {isLoading
            ? (
              <LoadingIcon
                stroke='#ffffff'
                style={{
                  width: '30px',
                  height: '30px'
                }}
              />
              )
            : (
                formatMessageIntlUtil(intl, workoutMessages.startWorkout)
              )}
        </Text>
      </ButtonPrimary>
    </View>
  )
}
